
import request from '@/axios/request1.js';
//设备管理-分页查询
export function getDeviceList(params) {
    return request.postJson('api/device/getDeviceList', params); 
  }
//设备管理-获取所属分组数据
  export function getGroupingData(params) {
    return request.get('api/device/getGroupingData' + '/' + params); 
  }
//能耗统计报表查询
  export function getEnergyReport(params) {
    return request.post('api/report/getEnergyReport', params); 
  }
  // 设备管理-获取详情
  export function getInfo(params) {
    return request.get('api/device/getInfo' + '/' + params); 
  }
//  智控日志-运行日志
export function getRunningLog(params) {
  return request.postJson('api/RunRecord/getRunningLog', params);
}
//  智控日志-控制类型
export function getDeviceTypes(params) {
  return request.get('api/device/getDeviceTypes', params);
}
// 控制类型-列表
export function getCtrlType() {
  return request.get('api/RunRecord/getCtrlType');                                                           
}
  // 获取设备类型
  export function getDeviceTypeData(params) {
    return request.get('api/device/getDeviceTypeData', params); 
  }
  // 根据分组获取设备列表
  export function getDeviceByProjectNumber(params) {
    return request.get('api/AirDevice/getDeviceByProjectNumber', params);
  }
  // 根据项目ID获取支路列表
  export function getMeterListById(params) {
    return request.get('api/admin/brancht/getMeterListById', params);
  }
  // 校验风机是否被其他设备关联
  export function checkCotRelatedIds(params) {
    return request.postJson('api/device/checkCotRelatedIds', params);
  }

  // 新增设备
  export function addDevice(params) {
    return request.postJson('api/device/addDevice', params);
  }
  // 编辑设备
  export function editDevice(params) {
    return request.postJson('api/device/editDevice', params);
  }
  // 根据设备类型获取设备编号和点位信息
  export function getPointInfoByDeviceType(params) {
    return request.postJson('api/device/getPointInfoByDeviceType', params);
  }
  // 根据设备类型获取设备列表
  export function getListByDeviceType(params) {
    return request.get('api/device/getListByDeviceType', params);
  }
  // 根据楼层获取设备列表
 export function getDeviceListByFloor(params) {
  return request.get('/api/device/getDeviceListByFloor', params);
}
  // 根据存在设备的所属分组数据
  export function getGroupingDataByNumber(params) {
    return request.get('/api/device/getGroupingDataByNumber' + '/' + params);
  }
  // export function getGroupingBaseDataByNumber(params) {
  //   return request.get('/api/device/getGroupingDataByNumber' + '/' + params);
  // }
  // 空开根据存在设备的所属分组数据
  export function getAirGroupingDataByNumber(params) {
    return request.get('api/airswitchDevice/getGroupingDataByNumber' + '/' + params);
  }
  export function getGroupByProject(params) {
    return request.get('api/RunRecord/getGroupByProject' + '/' + params);
  }
  // 根据监控界面设备类型
  export function getMonitorDeviceTypeData(params) {
    return request.get('api/device/getMonitorDeviceTypeData', params);
  }
  // //  导出设备相关联点位
  // export function exportDevicePoint(params) {
  //   let openurl = url.exportDevicePoint + params;
  //   location.href = openurl;
  // }
/**
 * 查询设备，按设备类型进行分组
 * @param {*} params
 */
 export function getDeviceListTree(params) {
  return request.postJson('api/device/getDeviceListTree', params);
}
  /**
 * 查询设备，按设备类型进行分组
 * @param {*} params
 */
export function getGroupDeviceTypeTree(params) {
  return request.get('api/device/getGroupDeviceTypeTree' + '/' + params);
}
/**
 * PLC同步
 */
 export function syncPlcSend(params) {
  return request.get('api/device/syncPlcSend' + params);
}
  /**
 * 数据同步
 * @param {*} projectNumber
 * @param {*} groupNumber
 */
 export function dataSync(projectNumber, groupNumber) {
    return request.get(
      `api/syncTable/start?projectNumber=${projectNumber}&groupNumber=${groupNumber}`
    );
  }
/**
 * 数据校验初始化
 */
 export function checkData(projectNumber) {
  return request.get(
    '/api/device/checkData?buildNumber=' + projectNumber
  );
}
/* ---------------------------------------------------------- */
// 分体空调监控界面
// 查询监控界面
export function getAirMonitorList(params) {
  return request.postJson('/api/airConditioner/getList', params);
}
// 获取监控界面信息
export function getAirMonitorInfo(params) {
  return request.get('/api/airConditioner/getInfo', params);
}
// 新增监控界面
export function addAirMonitor(params) {
  return request.postJson('/api/airConditioner/addAirImage', params);
}
// 编辑监控界面
export function editAirMonitor(params) {
  return request.postJson('/api/airConditioner/editAirImage', params);
}
// 根据设备类型获取设备列表
export function getAirListByDeviceType(params) {
  return request.get('/api/airConditioner/getListByDeviceType', params);
}
// 获取点信息列表
export function getAirMonitorDeviceList(params) {
  return request.get('/api/airConditioner/getMonitorDeviceList', params);
}
// 删除监控界面
export function deleteAirMonitor(params) {
  return request.get('/api/airConditioner/delAirImage', params);
}

// 分体空调设备管理
// 获取空调基本信息
export function getAirDeviceList(params) {
  return request.postJson('/api/airConditioner/getAirList', params);
}
// 获取详情
export function getAirConditionerInfo(params) {
  return request.get('/api/airConditioner/getAir', params);
}
 // 新增设备
export function addAirDevice(params) {
  return request.postJson('/api/airConditioner/addAir', params);
}
// 编辑设备
export function ediAirtDevice(params) {
  return request.postJson('/api/airConditioner/editAir', params);
}
// 删除设备
export function deleteAirConditioner(params) {
  return request.get('/api/airConditioner/delAir', params);
}
 //-------------------------------------分体空调---------------------------
  // 获取分体空调所有分组信息
  export function getAirGroupByProject(code) {
    return request.get(
      '/api/airConditioner/getGroupByProject?buildNumber=' + code
    );
  }
  // 获取分组下的空调信息
  export function getAirByGroup(params) {
    return request.get('/api/airConditioner/getAirByGroup', params);
  }
  //获取空调参数
  export function getAirInfo(params) {
    return request.postJson('/api/airConditioner/getAirInfo', params);
  }
  // 设置空调参数
  export function setAirParas(params) {
    return request.postJson('/api/airConditioner/setAirParas', params);
  }
  // 分页空调列表
  export function getAirList(params) {
    return request.postJson('/api/airConditioner', params);
  }
  // 获取空调能耗
  export function getAirEnergy(params) {
    return request.postJson('/api/airConditioner/getAirEnergy', params);
  }
  // a分体空调批量设置
  export function batchSetParam(params) {
    return request.postJson('/api/airConditioner/batchSetParam', params);
  }
  // 分体空调数据列表
  export function getAirDataList(params) {
    return request.postJson('/api/airConditioner/getAirDataList', params);
  }
/* ---------------------------------------------------------- */
export function getEndMonitorList(params) {
  return request.postJson('api/endMonitor/getList', params);
}
// 新增监控界面
export function addMonitor(params) {
  return request.postJson('api/ctrlMonitorInterface/add', params);
}
export function getMonitorList(params) {
  return request.postJson('api/ctrlMonitorInterface/getList', params);
}
// 编辑监控界面
export function editMonitor(params) {
  return request.postJson('api/ctrlMonitorInterface/edit', params);
}
// 删除监控界面
export function deleteMonitor(params) {
  return request.get('api/ctrlMonitorInterface/delete', params);
}
// 获取监控界面信息
export function getMonitorInfo(params) {
  return request.get('api/ctrlMonitorInterface/getInfo', params);
}
// 获取监控界面图片
export function getPicture(params) {
  return request.post('api//ctrlMonitorInterface/getPicture', params);
}
// 获取点信息列表
export function getMonitorDeviceList(params) {
  return request.get('api/ctrlMonitorInterface/getMonitorDeviceList', params);
}
// 批量新增点信息
export function addMonitorDeviceBatch(params) {
  return request.post('api/ctrlMonitorInterface/addMonitorDeviceBatch', params);
}
// 查询房间列表
export function getRoomList(params) {
  return request.postJson('api/room/getRoomList', params);
}
// 删除房间
export function deleteRoom(params) {
  return request.post('api/room/deleteRoom', params);
}
// 新增房间
export function addRoom(params) {
  return request.postJson('api/room/addRoom', params);
}
// 编辑房间
export function editRoom(params) {
  return request.postJson('api/room/editRoom', params);
}
// 房间管理-建筑楼层树
export function getFloorTree (params) {
  return request.post('api/room/getFloorTree' , params);
}
// 获取房间树
export function getRoomTree(params) {
  return request.postJson('api/room/getRoomTree', params);
}
// 设备解锁
export function unlockDeviceCheck(params) {
  return request.get('/api/airswitchDevice/unlockDeviceCheck', params);
}
// 修改设备手自动
export function modifyAutoCtrl(params) {
  return request.get('/api/device/modifyAllowAutoCtrl'+`/${params.deviceId}/${params.val}`);
}
// 获取加班房间树
// export function getRoomTreeHasDev(params) {
//   return request.get(url.getRoomTreeHasDev, params);
// }
// 编辑配电箱设备信息
export function getBoxDevice(params) {
  return request.get('/api/airswitchDevice/getBoxDevice', params);
}
// 设备分析--某个设备所有的待处理报警
export function getPendingAlarmsOfOneDev(params) {
  return request.get('/api/airswitchRunStat/getPendingAlarmsOfOneDev',params);
}
// 获取设备树
export function getDeviceTreeNew(params) {
  return request.get('/api/airswitchMode/getDeviceTreeNew', params);
}
// 设备树多选(建筑--楼栋--楼层--设备)
export function getDeviceTreeMulti(params) {
  return request.postJson('api/room/getDeviceTreeMulti', params);
}
// 设备解锁校验
export function unlockDevice(params) {
  return request.get('/api/airswitchDevice/unlockDevice', params);
}
// 编辑详细参数
export function getDeviceConInfo(params) {
  return request.post('/api/airswitchDevice/getDeviceConfInfo', params);
}
// 获取设备树
export function getDeviceTree(params) {
  return request.postJson('api/room/getDeviceTree', params);
}
// // 控制权限秘钥设置
// export function setControlPwd(params) {
//   return request.post(url.setControlPwd, params);
// }
// // 获取项目所属空开网关
// export function getGateway(params) {
//   return request.get(url.getGateway, params);
// }
// // 获取网关报警阈值参数
// export function getGatewayAlarmParam(params) {
//   return request.get(url.getGatewayAlarmParam, params);
// }
// 获取手动控制日志
export function getHandLog(params) {
  return request.postJson('/api/airswitchLog/getHandLog', params);
}
// 获取自动控制日志
export function getAutoModes(params) {
  return request.get(
    '/api/airswitchLog/getAutoModes' + '?buildNumber=' + params
  );
}
// 获取自动控制日志明细
export function getAutoLogDetail(params) {
  return request.postJson('/api/airswitchLog/getAutoLogDetail', params);
}
// 获取智控日志自定义列表
export function getCustomColumns(params) {
  return request.get( '/api/airswitchLog/getCustomColumns', params);
}
// 编辑智控日志自定义列表
export function editCustomColumns(params) {
  return request.post('/api/airswitchLog/editCustomColumns', params);
}
// 查询监控界面
export function getList(params) {
  return request.postJson('/api/airswitchDevice/getList', params);
}
// 获取空开监控界面数组
export function getMonitorInterface(params) {
  return request.postJson('/api/airswitchDevice/getMonitorInterface', params);
}
// 获取监控界面数组
export function getDevicesOfInterface(params) {
  return request.get('/api/airswitchDevice/getDevicesOfInterface',  params);
}
// 获取设备id获取数组
export function getDeviceAndInterfaceById(params) {
  return request.get('/api/airswitchDevice/getDeviceAndInterfaceById', params);
}
/**
 * 新增操作日志
 * @param {*} params
 */
 export function addLog(params) {
  return request.postJson('/api/webOperation/add', params);
}
// 校验权限
export function checkCrlPermission(params) {
  return request.postJson('/api/airswitchDevice/checkCrlPermission', params);
}
// 获取设备详情参数
export function getDetailOfDevice(params) {
  return request.postJson('/api/airswitchDevice/getDetailOfDevice', params);
}
// 获取设备逐时功率
export function getPowerOfDevice(params) {
  return request.postJson('/api/airswitchDevice/getPowerOfDevice', params);
}
// 获取控制树
export function getControlDeviceTree(params) {
  return request.get('/api/airswitchAnalyse/getDeviceTree', params);
}
// 编辑详细参数
export function editDetailOfDevice(params) {
  return request.postJson('/api/airswitchDevice/editDetailOfDevice', params);
}
// 批量设置
export function batchOnOff(params) {
  return request.postJson('/api/airswitchDevice/batchOnOff', params);
}
// 模式列表
export function getModeList(params) {
  return request.postJson('/api/airswitchMode/getModeList', params);
}
// 自定义列表
export function ctrlModeCus(params) {
  return request.get('/api/airswitchLog/getCustomColumns/ctrlMode', params);
}
// 获取模式详情
export function getMode(params) {
  return request.get('/api/airswitchMode/getMode', params);
}
// 编辑模式
export function editMode(params) {
  return request.postJson('/api/airswitchMode/editMode', params);
}
// 新增模式
export function addMode(params) {
  return request.postJson('/api/airswitchMode/addMode', params);
}
// deleteMode
export function deleteMode(params) {
  return request.get('/api/airswitchMode/deleteMode', params);
}
// 提醒人列表
export function getRemindUserList(params) {
  return request.get('/api/airswitchMode/getRemindUserList', params);
}
// 用户列表
export function getUserList(params) {
  return request.get('/api/airswitchMode/getUserList', params);
}
// 启用禁用
export function updateStatus(params) {
  return request.postJson('/api/airswitchMode/updateStatus', params);
}
// 查询列表
export function getWorkList(params) {
  return request.postJson('/api/workLateInfo/getList', params);
}
// 获取详情
export function getWorkInfo(params) {
  return request.get('/api/workLateInfo/getInfo/'+ params);
}
// 获取审批类型
export function getCheckType(params) {
  return request.get('/api/workLateInfo/getConfigParam/'+ params);
}
// 修改加班申请
export function editApply(params) {
  return request.postJson('/api/workLateInfo/editApply',params);
}
// 加班申请操作
export function controlApply(params) {
  return request.postJson('/api/workLateInfo/controlApply',params);
}
// 加班申请新增
export function addApply(params) {
  return request.postJson('/api/workLateInfo/addApply',params);
}
// 加班申请新增
export function setCheckType(params) {
  return request.postJson('/api/workLateInfo/updateConfigParam',params);
}
// 指导运行
export function getRunAdvice(params) {
  return request.get('/api/airswitchRunStat/getRunAdvice',params);
}
// 今日运行统计
export function getTodayData(params) {
  return request.get('/api/airswitchRunStat/getTodayData',params);
}
// 设备树
export function getDeviceAlyTree(params) {
  return request.get('/api/airswitchAnalyse/getDeviceTree',params);
}
// 设备资料
export function getDeviceInfo(params) {
  return request.get('/api/airswitchAnalyse/getDeviceInfo',params);
}
// 预警告警趋势
export function getAlarmWarningTrend(params) {
  return request.postJson('/api/airswitchAnalyse/getAlarmWarningTrend',params);
}
// 运行参数记录
export function getRunRecordOfParams(params) {
  return request.get('/api/airswitchAnalyse/getRunRecordOfParams',params);
}
// 负荷趋势
export function getEnergyLoad(params) {
  return request.get('/api/airswitchRunStat/getEnergyLoad',params);
}
// 告警预警类别排名
export function getAlarmRank(params) {
  return request.get('/api/airswitchRunStat/getAlarmRank',params);
}
// 告警预警类别占比
export function getAlarmTimeRatio(params) {
  return request.get('/api/airswitchRunStat/getAlarmTimeRatio',params);
}
// 一年内告警预警趋势
export function getAlarmTrendOfYear(params) {
  return request.get('/api/airswitchRunStat/getAlarmTrendOfYearNew2',params);
}
// 科室用能超限额统计
export function getOverEnergyQuotaOfOrgs(params) {
  return request.post('/api/airswitchRunStat/getOverEnergyQuotaOfOrgs',params);
}
// 当前报警
export function getPendingAlarms(params) {
  return request.post('/api/airswitchRunStat/getPendingAlarms',params);
}
// 获取改造前用能情况
export function getEnergySetInfo(params) {
  return request.get('/api/airswitchRunStat/getEnergySetInfo',params);
}
// 设置改造前用能情况
export function setEnergySetInfo(params) {
  return request.postJson('/api/airswitchRunStat/setEnergySetInfo',params);
}
// 自定义报警
export function alarmAdd(params) {
  return request.postJson('/api/alarmConditionInt/add', params);
}
export function alarmEdit(params) {
  return request.postJson( '/api/alarmConditionInt/edit',params);
}
export function getAlarmLevels(params) {
  return request.get('/api/alarmConditionInt/getAlarmLevels',params);
}
export function alarmDelete(params) {
  return request.get('/api/alarmConditionInt/del',params);
}
export function alarmEditBatch(params) {
  return request.postJson('/api/alarmConditionInt/editBatch',params);
}
export function alarmAdminListQuery(params) {
  return request.get('/api/alarmConditionInt/getUserList/'+params);
}
export function alarmGetInfo(params) {
  return request.get('/api/alarmConditionInt/getAlarmConditionInfo',params);
}
export function alarmQueryList(params) {
  return request.postJson('/api/alarmConditionInt/pageAlarmConditions',params);
}
// export function configTypeQuery(params) {
//   return request.get( '/api/alarmCondition/getArray/'+params);
// }
export function alarmGetDevicePicture(params) {
  return request.postJson( '/api/alarmCondition/getDevicePicture', params);
}
export function alarmDeviceTreeQuery(params) {
  return request.postJson('/api/alarmCondition/getDeviceTree',params);
}
// 报警看板 /alarm/getAlarmBoardInfo
export function getAlarmBoardInfo(params) {
  return request.postJson( `/api/alarm/getAlarmBoardInfo`,params);
}
// 获取播报参数
export function getVoiceParam(params) {
  return request.get( `/api/alarm/getVoiceParam`,params);
}
// 设置语音播报参数
export function setVoiceParam(params) {
  return request.postFormData( `/api/alarm/setVoiceParam`,params);
}
// 根据系统类型获取监控对象
export function getMonitorObjectsByType(params) {
  return request.get('/api/alarmConditionInt/getMonitorObjectsByType',params);
}
export function getMonitorObjects(params) {
  return request.get('/api/alarmConditionInt/getMonitorObjects/'+params);
}
/**
 * 获取设备类型列表或树 1-6(供配电、给排水、空调、电梯、能管、全部), 1/0(1:下拉，0:下拉树)
 * @return {
 *  array
 * }
 */
export function deviceTypeQuery(params = {}) {
  return request.get('/api/alarmConditionInt/getMonitorObjectsByType'.replace("$1", params.deviceType).replace("$2", params.flat)
  );
}
export function alarmParameterQuery(params) {
  return request.postJson('/api/alarmConditionInt/getParameter',params);
}
export function alarmPointMappingQuery(params) {
  return request.post('/api/alarmCondition/getPointMapping',params);
}
export function transformerGetArray(params) {
  return request.post('/api/alarmCondition/getTransformerArray'+params);
}
// 查询报警列表
export function getAlarmList(params) {
  return request.postJson('/api/alarm/pageAlarms', params);
}
/**
 * 忽略报警
 * @param {} params
 */

 export function ignoreAlarm(params) {
  return request.post('/api/alarm/ignoreAlarm', params);
}
/**
 * 获取报警条件树
 * @param {*} params ：项目编码
 */
 export function getAlarmConditionTree(params) {
  return request.get('/api/alarm/getAlarmConditionTree/' + params);
}
/**
 * 根据设备id获取历史报警数据
 */
 export function getHistryAlarmListByDeviceId(params) {
  return request.postJson('/api/alarm/pageHistoryAlarms', params);
}
/**
 * 根据设备id获取历史报警数据
 */
 export function getAlarmGroupByAlarmType(params) {
  return request.get('/api/alarm/getAlarmGroupByAlarmType', params);
}
/**
 * 用能报警
 */
 export function getEnergyAlarmList(params) {
  return request.get('/api/alarm/getEnergyAlarmList/'+params);
}
// 推送配置
/**
 * 用能报警
 */
 export function addPushTemplate(params) {
  return request.postJson('/api/alarmPush/addPushTemplate',params);
}
 export function deletePushTemplate(params) {
  return request.get('/api/alarmPush/deletePushTemplate',params);
}
 export function getPushInfoList(params) {
  return request.postJson('/api/alarmPush/getPushInfoList',params);
}
 export function getPushSelected(params) {
  return request.get('/api/alarmPush/getPushSelected',params);
}
 export function getPushTemplateInfo(params) {
  return request.get('/api/alarmPush/getPushTemplateInfo',params);
}
 export function getPushTemplateList(params) {
  return request.get('/api/alarmPush/getPushTemplateList',params);
}
 export function getPushUserList(params) {
  return request.postJson('/api/alarmPush/getUserList',params);
}
/**
 * 添加新增钉钉群接口
 */
 export function addDingGroup(params) {
  return request.postJson('/api/pushDingGroup/add', params);
}
/**
 * 获取钉钉群接口
 */
export function getDingList(projectNumber) {
  return request.get(
    '/api/pushDingGroup/getList/'+ projectNumber
  );
}
// 行业标准
 export function getProfessionStandard(params) {
  return request.get('/api/buildQuota/getProfessionStandard',params);
}
 export function getDefaultStandard(params) {
  return request.get('/api/professionStandard/getDefaultStandard',params);
}
 export function getStandard(params) {
  return request.get('/api/buildQuota/getStandard',params);
}
 export function addProfessionStandard(params) {
  return request.postJson('/api/professionStandard/addProfessionStandard',params);
}
 export function updateProfessionStandard(params) {
  return request.postJson('/api/professionStandard/updateProfessionStandard',params);
}
 export function getCalculateDetail(params) {
  return request.get('/api/buildQuota/getCalculateDetail',params);
}
/**
 * 导出报警
 */
 export function exportAlarmList(params) {
  return request.post('/api/alarm/exportAlarmList', params);
}
// 校验
export function validMode(params) {
  return request.get('/api/airswitchMode/validMode',params);
}
// 数据采集列表
export function getBillListCollo(params) {
  return request.postJson('/api/energyCollect/pageEnergyCollects',params);
}
export function getBillInfoCollo(params) {
  return request.get('/api/energyCollect/getBillInfo',params);
}
export function confirmInput(params) {
  return request.postJson('/api/energyCollect/confirmArchive',params);
}
export function checkBill(params) {
  return request.postJson('/api/energyCollect/checkEnergyCollect',params);
}
export function getDataEntryList(params) {
  return request.postJson('/api/energyCollect/pageDataEntrys',params);
}
export function getDataEntryLogList(params) {
  return request.postJson('/api/energyCollect/pageDataEntryLogs',params);
}
let ctrlExperienceService={
  getCtrlParamSelected:(params)=>{
    return request.get('/api/Experience/getCtrlParamSelected', params);
  },
  setConfig:(params)=>{
    return request.post('/api/Experience/setConfig',  params);
  }
};
// 权限列表
export function getPnumberList(params){
  return request.get('/api/permission/getPnumberList',params);
}
export function getListPression(params){
  return request.post('/api/permission/getList',params);
}
// 自定义报警
export function getDiyAlertInfo(params){
  return request.get('/api/alert/getDiyAlertInfo',params);
}
export function getTypeArray(params){
  return request.get('/api/system/getTypeArray',params);
}
export function getCollectorArray(params){
  return request.get('/api/collector/getArray',params);
}
export function addDiyAlert(params){
  return request.post("/api/admin/alert/addDiyAlert",params);
}
export function getexLeftTree(params){
  return request.get("api/admin/expenses/getLeftTree",params);
}
export function editDiyAlert(params){
  return request.post('/api/alert/editDiyAlert',params);
}
export {ctrlExperienceService};

// 能源审计
export function getAuditArchive(params){
  return request.postJson('/api/auditInfo/getAuditArchive/page',params)
}
export function getManageList(params){
  return request.postJson('api/auditInfo/page',params)
}
